import React from 'react';
import axios from "axios";
import { BUBBLE_LOADING, META_FACEBOOK, BREADCRUMB_SCHEMA } from '../../constants/FrontEndConstant';
import { LANGUAGE_CODE, API_URL, META_TITLE_APPEND } from '../../constants/DotEnv';
import ImpressumHeader from '../subPageHeader/SubPageHeader';
class Impressum extends React.Component {
    constructor() {
        super();
        this.state = {
            impressumdata: {},
            loading: 'false',
            dataLength: '',
            title: ''
        }
    }
    componentWillUnmount() {
        setTimeout(() => {
            window.setOgTag(META_FACEBOOK['og_title'], META_FACEBOOK['og_description'], META_FACEBOOK['og_image'], META_FACEBOOK['og_url'])
            window.removeSchema();
        }, 100)
    }
    componentDidMount() {
        this.scrollUpFunction();
        this.impressumContent();
        setTimeout(() => {
            var schema2 = window.positionCreate(BREADCRUMB_SCHEMA['impressum']['schema2']['position'], BREADCRUMB_SCHEMA['impressum']['schema2']['url'], BREADCRUMB_SCHEMA['impressum']['schema2']['name']);
            var schemaObject = window.schemaObj(BREADCRUMB_SCHEMA['schema1'], schema2, BREADCRUMB_SCHEMA['impressum']['schema3']);
            window.setSchema(schemaObject);
        }, 100)
    }
    scrollUpFunction = () => {
        /**for scrolling up page */
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
        let count = document.querySelector('.navbar-toggler').className.indexOf("collapsed");
        if (count === -1) {
            document.querySelector('.navbar-collapse').classList.remove('show');
            document.querySelector('header').classList.remove("header_collapse");
            document.querySelector('.navbar-toggler').setAttribute("aria-expanded", false);
        }
    }
    impressumContent = async () => {
        this.setState({ loading: 'true' })
        let self = this;
        let impressumdata = '';
        let dataLength = '';
        let title = '';
        let meta_title = '';
        let meta_description = '';
        let meta_keywords = '';
        let og_title = '';
        let og_description = '';
        let og_image = '';
        await axios.get(API_URL + '/cms/getCmsByID/90/' + LANGUAGE_CODE)
            .then((response) => {
                impressumdata = response.data.success.cms;
                dataLength = Object.keys(impressumdata).length;
                title = impressumdata['title'];
                meta_title = impressumdata['title'] + META_TITLE_APPEND;
                meta_keywords = impressumdata['metakeyword'];
                meta_description = impressumdata['metadescription'];
                og_title = impressumdata['title'] + META_TITLE_APPEND;
                og_description = impressumdata['metadescription'];
                og_image = META_FACEBOOK['og_image'];
                window.setMeta({ "description": meta_description, "keywords": meta_keywords });
                window.setOgTag(og_title, og_description, og_image, window.location.href)
                window.setDocumentTitle(meta_title)
                self.setState({ loading: 'false', impressumdata, dataLength, title })
            })
            .catch((error) => {
                self.setState({ loading: 'false' })
            })
    }
    render() {
        let length = Object.keys(this.state.impressumdata).length
        let impressumdata = this.state.impressumdata;
        return (
            <main>
                {(this.state.loading === 'true') ?
                    BUBBLE_LOADING
                    : null
                }
                <ImpressumHeader data={impressumdata} title={this.state.title} dataLength={this.state.dataLength} />
                {(length > 0 && this.state.loading === 'false') ?
                    <section>
                        <div className="container">
                            <div className="row mx-0">
                                <div dangerouslySetInnerHTML={{ __html: impressumdata['content'] }}></div>
                            </div>
                        </div>
                    </section>
                    : null
                }
            </main>
        );
    }
}
export default Impressum;